import type { ReceiptTemplate } from '../schema';

export const cvsTemplate: ReceiptTemplate = {
  id: 'cvs-pharmacy',
  name: 'CVS Pharmacy Receipt',
  brand: 'CVS PHARMACY',
  description: 'Pharmacy and retail store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'cvs-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/cvs.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'CVS/pharmacy #0127',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cvs-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'STORE: 0127  REG: 02  TRANS: 8472\n01/04/26  14:23:41  CASHIER: JAMES',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'cvs-extracare',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ExtraCare Card *********4144',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'cvs-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'cvs-item-1', name: 'ADVIL 200MG 100CT', quantity: '1', price: '12.99'},
          { id: 'cvs-item-2', name: 'CVS TISSUE 3PK', quantity: '1', price: '5.49'},
          { id: 'cvs-item-3', name: 'BANDAID VARIETY', quantity: '1', price: '6.29'},
          { id: 'cvs-item-4', name: 'SNICKERS BAR', quantity: '2', price: '1.89'},
          { id: 'cvs-item-5', name: 'WATER 1L', quantity: '1', price: '2.19'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'cvs-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'cvs-subtotal', label: 'SUBTOTAL', value: '30.74', isBold: false, isLarge: false },
          { id: 'cvs-ec-savings', label: 'EC SAVINGS', value: '-3.00', isBold: false, isLarge: false },
          { id: 'cvs-tax', label: 'TAX', value: '2.46', isBold: false, isLarge: false },
          { id: 'cvs-total', label: 'TOTAL', value: '30.20', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'cvs-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'cvs-card', label: 'DEBIT', value: '************4144' },
          { id: 'cvs-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'cvs-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '*** EXTRACARE REWARDS ***\nYOU SAVED: $3.00 TODAY\nEXTRABUCKS AVAILABLE: $2.00',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'cvs-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '01270284720104',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cvs-survey',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TELL US ABOUT YOUR VISIT\nCVS.COM/SURVEY\nWIN $1000 GIFT CARD',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

